import { toast } from "react-toastify";
import api from "../../BrandOnBoarding/api";

import {
  FETCH_SENTIMENT_REQUEST,
  FETCH_SENTIMENT_SUCCESS,
  FETCH_SENTIMENT_FAILURE,
  CREATE_SENTIMENT_REQUEST,
  CREATE_SENTIMENT_SUCCESS,
  CREATE_SENTIMENT_FAILURE,
  UPDATE_SENTIMENT_REQUEST,
  UPDATE_SENTIMENT_SUCCESS,
  UPDATE_SENTIMENT_FAILURE,
  DELETE_SENTIMENT_REQUEST,
  DELETE_SENTIMENT_SUCCESS,
  DELETE_SENTIMENT_FAILURE,
  FETCH_USERSET_REQUEST,
  FETCH_USERSET_SUCCESS,
  FETCH_USERSET_FAILURE,
  CREATE_USERSET_REQUEST,
  CREATE_USERSET_SUCCESS,
  CREATE_USERSET_FAILURE,
  UPDATE_USERSET_REQUEST,
  UPDATE_USERSET_SUCCESS,
  UPDATE_USERSET_FAILURE,
  DELETE_USERSET_REQUEST,
  DELETE_USERSET_SUCCESS,
  DELETE_USERSET_FAILURE,
  FETCH_SHARE_USERS_REQUEST,
  FETCH_SHARE_USERS_SUCCESS,
  FETCH_SHARE_USERS_FAILURE,
} from "../constants/actionTypes";

export const fetchuserSentiment =
  ({ customer_id, user_id }) =>
  async (dispatch) => {
    dispatch({ type: FETCH_SENTIMENT_REQUEST });
    try {
      const response = await api.get(
        `/userset/sentiment-list/${customer_id}/${user_id}`
      );
      dispatch({ type: FETCH_SENTIMENT_SUCCESS, payload: response.data.data });
    } catch (error) {
      dispatch({ type: FETCH_SENTIMENT_FAILURE, error: error.message });
      throw error;
    }
  };

export const createUserSet =
  ({ customer_id, user_id, name, MetricSettingId, isDefault, customIndexScoreType }) =>
  async (dispatch) => {
    dispatch({ type: CREATE_USERSET_REQUEST });
    let body = { customer_id, user_id, name, MetricSettingId, isDefault };
    if (customIndexScoreType) {
      body.customIndexScoreType = customIndexScoreType;
    }
    try {
      const response = await api.post(`/userset/create/userset`, body);
      dispatch({ type: CREATE_USERSET_SUCCESS });
      // ✅ dispatching another thunk properly
      toast.success("Template create successfully");

      await dispatch(fetchuserSet({ customer_id, user_id }));
    } catch (error) {
      toast.error("Fail to create  Template");
      dispatch({ type: CREATE_USERSET_FAILURE, error: error.message });
      throw error;
    }
  };

  export const updateUserSet =
  ({user_id, name,id,customer_id,isDefault  }) =>
  async (dispatch) => {
    dispatch({ type: "REQUEST" });
    let body = { id, user_id, name, isDefault, customer_id };
    try {
      const response = await api.post(`/userset/update/userset`, body);
      dispatch({ type: "SUCCESS" });
      // ✅ dispatching another thunk properly
      toast.success("Template update successfully");

      await dispatch(fetchuserSet({ customer_id, user_id }));
    } catch (error) {
      toast.error("Fail to update  Template");
      dispatch({ type: "FAILED", error: error.message });
      throw error;
    }
  };


export const createAttribute =
  ({ attribute, MetricSettingId, type,key ,definition, factor}) =>
  async (dispatch) => {
    dispatch({ type: "REQUEST" });
    let body = { attribute, MetricSettingId, type,definition, factor };
    try {
      const response = await api.post(`/userset/create/attribute`, body);
      dispatch({ type: "SUCCESS" });
      toast.success(`${key??type} added successfully`);
      return response.data.data;

      // await dispatch(fetchuserSet({ customer_id, user_id }));
    } catch (error) {
      toast.error(`Fail to add  ${ key??type}`);
      dispatch({ type: "FAILED", error: error.message });
      throw error;
    }
  };

export const updatingAttribute =
  ({ attribute, id, type, key,definition, factor }) =>
  async (dispatch) => {
    dispatch({ type: "REQUEST" });
    let body = { attribute, id, type,definition, factor };
    try {
      const response = await api.post(`/userset/update/attribute`, body);
      dispatch({ type: "SUCCESS" });
      toast.success(`${key??type} update successfully`);
      return response.data.data;
    } catch (error) {
      toast.error(`Fail to update  ${ key??type }`);
      dispatch({ type: "FAILED", error: error.message });
      throw error;
    }
  };

export const fetchuserSet =
  ({ customer_id, user_id }) =>
  async (dispatch) => {
    dispatch({ type: FETCH_USERSET_REQUEST });
    try {
      const response = await api.get(
        `/userset/get/userset/${customer_id}/${user_id}`
      );
      /*want to set default metricSettingId*/
      if(response?.data?.data?.length){
       let defaultSet= response.data.data.find((ele)=>ele.isDefault);
          dispatch({ type: "SET_METRICE_SETTING_ID", payload: defaultSet?.id??"default" });
          dispatch({ type: "SET_BRAND_AUDIT_METRICE_SETTING_ID", payload: defaultSet?.id??"default" });
      }
      dispatch({ type: FETCH_USERSET_SUCCESS, payload: response.data.data });
      // toast.success("User Metric Setting fetch successfully");
    } catch (error) {
      toast.error("Fail to fetch  User Metric Setting");
      console.log("fail to fetch user metric setting ", error);
      dispatch({ type: FETCH_USERSET_FAILURE, error: error.message });
      throw error;
    }
  };

// Fetched once per session — guarded below so a second mount/modal-open (this
// session) never re-hits the network once the list has already loaded, or
// while a request is already in flight. A failed fetch is retryable, since
// `loaded` only flips true on success.
export const fetchShareUsers = () => async (dispatch, getState) => {
  const { loading, loaded } = getState().shareUsers;
  if (loading || loaded) return;

  dispatch({ type: FETCH_SHARE_USERS_REQUEST });
  try {
    const response = await api.get(`/userset/share/users`);
    dispatch({ type: FETCH_SHARE_USERS_SUCCESS, payload: response?.data?.users ?? [] });
  } catch (error) {
    dispatch({ type: FETCH_SHARE_USERS_FAILURE, error: error.message });
  }
};

export const deleteAttribute =
  ({ id, type,key }) =>
  async (dispatch) => {
    dispatch({ type: "REQUEST" });
    try {
      await api.delete(`/userset/delete/attribute/${id}`);
      dispatch({ type: "SUCCESS" });
    } catch (error) {
      toast.error(`Fail to delete ${key??type}`);
      dispatch({ type: "FAILED", error: error.message });
      throw error;
    }
  };

export const deleteMetricSetting =
  ({ id }) =>
  async (dispatch) => {
    dispatch({ type: "REQUEST" });
    try {
      await api.delete(`/userset/delete/metricsetting/${id}`);
            toast.success(`setting delete successfully`);
      dispatch({ type: "SUCCESS" });
    } catch (error) {
      toast.error(`Fail to delete setting`);
      dispatch({ type: "FAILED", error: error.message });
      throw error;
    }
  };

